import { UPLOAD_EXCEL_ORDER_MODAL as FEATURE_PREFIX } from 'featurePrefix.ids'

const UPLOAD_EXCEL_MODAL = 'upload-excel-orders-modal'

export const UploadExcelModalIds = {
  ModalTitleId: `${FEATURE_PREFIX}__${UPLOAD_EXCEL_MODAL}__title`,
  UploadButtonId: `${FEATURE_PREFIX}__${UPLOAD_EXCEL_MODAL}__upload-button`,
}
